/**
 *  @deprecated use funtion sendEvent(type, element, data).
 */
function trackEvent(type, element, data) {
    sendEvent(type, element, data)
}

export function sendEvent(type, element, data) {
    console.log("--> analitycs::sendEvent(" + type + ", " + element + ", {...})");
    // console.log(data);
    // if (!window.location.hostname.includes("adopta-un-animal.es")) {
    //     console.log("entorno no productivo -> sin enviar evento");
    // } else {
    let domain
    if ((/www|pre|localhost/gmi).test(window.location.origin)) {
        domain = window.location.origin
    } else if ((/tienda/gmi).test(window.location.origin)) {
        domain = "https://www.adopta-un-animal.es";
    }
    let viewerLatLngStr, viewerLatlng
    try {
        viewerLatLngStr = localStorage?.getItem('viewerLatLng');
        viewerLatlng = JSON.parse(viewerLatLngStr)
    } catch (e) {
        console.log("LocalStorage is not accesible");
    }
    
    const timestamp = new Date().getTime()
    const objRequest = {
        type: 'POST',
        url: domain + "/api/analitycs/trackEvent",
        dataType: 'json',
        contentType: 'application/json',
        beforeSend: function (req) {
            if(viewerLatlng?.lat) req.setRequestHeader('adopta-viewer-latitude', viewerLatlng?.lat);
            if(viewerLatlng?.lng) req.setRequestHeader('adopta-viewer-longitude', viewerLatlng?.lng);
        },
        data: JSON.stringify({
            type: type,
            element: element,
            data: data,
            evt: timestamp,
            evt_fecha: new Date(timestamp).toISOString()
        }),
    }
    $.ajax(objRequest)
        .done((response, textStatus, jqXHR) => {
            // console.log("--> analitycs::sendEvent(" + type + "," + element + ") -> ok");
        })
        .fail((jqXHR, textStatus, errorThrown) => {
            let errorStr;
            // console.log("--> analitycs::sendEvent(" + type + "," + element + ") -> fail");
            
            if (typeof jqXHR.responseJSON === "object" && Array.isArray(jqXHR.responseJSON)) {
                errorStr = jqXHR.responseJSON.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
            } else {
                errorStr = jqXHR.statusText + ": " + jqXHR.responseText;
            }
            
            if (console && console.log) {
                console.log("La solicitud a fallado: " + errorStr);
            }
        });
}
